import { LazyIssueApp } from '@jira/issue__lazy-app/src/LazyIssueApp.tsx';
import { currentUserResource } from '@jira/router-resources__current-user/src/useCurrentUserResource.tsx';
import { aiEntitlementResource } from '@jira/router-resources__ai-entitlement/src/aiEntitlementResource.tsx';
import { TEAM_MANAGED_BACKLOG } from '@jira/platform__observability-capabilities/src/constants.tsx';
import {
	forgeBacklogModuleResource,
	forgeSprintModuleResource,
} from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { backlogResource } from '@jira/router-resources__next-gen-backlog/src/backlogResource.tsx';
import { backlogFilterRefinementResource } from '@jira/router-resources__next-gen-backlog/src/backlogFilterRefinementResource.tsx';
import { epicsLiteResource } from '@jira/router-resources__next-gen-backlog/src/epicsLiteResource.tsx';
import { permissionsResource } from '@jira/router-resources__next-gen-backlog/src/permissionsResource.tsx';
import { confluenceUserPermissionsResource } from '@jira/router-resources__confluence-user-permissions/src/confluenceUserPermissionsResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { softwareBacklogEmbedRoute } from '@jira/router-routes__software-backlog-routes/src/softwareBacklogEmbedRoute.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { backlogPageEntrypoint, GSNBacklogPageEntrypoint } from './ui/index.tsx';

export const softwareBacklogEmbedRouteEntry: Route = createEntry(softwareBacklogEmbedRoute, () => ({
	group: 'software',
	layout: createLayout({
		isChromeless: true,
	}),
	resources: [
		...getNavigationResources(),
		...getIssueViewResources(),
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		backlogResource,
		backlogFilterRefinementResource,
		forgeBacklogModuleResource,
		forgeSprintModuleResource,
		...jiraSpaResources(),
		aiEntitlementResource,
		resourceWithCondition(() => !__SERVER__ || fg('enable_ssr_for_cmp_backlog'), epicsLiteResource),
		currentUserResource,
		permissionsResource,
		resourceWithCondition(
			() => fg('twcg-992-loom-meeting-notes-sprint-planning-gate'),
			confluenceUserPermissionsResource,
		),
	],
	afterPaint: [LazyIssueApp],
	entryPoint: () => (fg('navx-global-side-nav') ? GSNBacklogPageEntrypoint : backlogPageEntrypoint),
	ufoName: 'next-gen-backlog-embed',
	meta: {
		capability: TEAM_MANAGED_BACKLOG,
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
	isStreamingEnabled: fg('jfp-magma-ssr-streaming-enable-backlog'),
}));
